import { useState } from 'react';

import { useStores } from '../../../../lib/store';
import ChatService from '../../../../services/ChatService';

/**
 * Toggle like for DM
 *
 * @param {object} message
 * @param {string} memberId DM user ID
 *
 * @returns {Array} Returns liked state and function to toggle Like
 *
 * @author Gihan S <gihanshp@gmail.com>
 */
export default function useToggleLike(message, memberId) {
    const { _id, likes, chat: chatId } = message;
    const { userStore, chatStore } = useStores();

    const toggleLike = () => {
        const messageData = {
            creator: {
                payload: {
                    id: userStore.getUserId,
                },
            },
            thread: message,
            chat_id: chatId,
            isThread: false,
            key: _id,
        };
        // Add updated item with like/unlike changes instantly to state
        const chats = chatStore.getCachedDMs(memberId, 'Toggle Like');

        let totalLikes = 0;
        let likeDelta = 0;
        const updatedChatState = chats.map((item) => {
            if (item._id === _id) {
                let users = item.likes.users;
                const hasLiked =
                    // users can be eitehr object array or string array
                    users?.findIndex((user) => {
                        if (typeof user === 'string') {
                            return user === userStore.getUserId;
                        }
                        return user._id === userStore.getUserId;
                    }) > -1;
                if (hasLiked) {
                    // remove
                    users = users.filter((user) => {
                        if (typeof user === 'string') {
                            return user !== userStore.getUserId;
                        }
                        user._id !== userStore.getUserId;
                    });
                    likeDelta = -1;
                } else {
                    // add
                    users = [...users, userStore.getUserProfile];
                    likeDelta = 1;
                }
                totalLikes = hasLiked ? likes.count - 1 : likes.count + 1;
                const data = {
                    ...item,
                    likes: {
                        count: totalLikes,
                        users,
                    },
                };
                return data;
            }
            return item;
        });

        // update store
        chatStore.cacheDirectMessages(
            updatedChatState,
            memberId,
            'handleThreadPress'
        );
    };

    return toggleLike;
}
